import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const PersonModule = {
  namespaced : true,
  state      : {
    //- Selected User for user details
    person: null,
  },
  getters,
  actions,
  mutations
}

export default PersonModule